/* eGURU — làm trang About "sống" hơn (chỉ chạy trên trang About).
   1) Scroll-reveal: khối/ảnh trượt + mờ dần khi cuộn tới.
   2) Số 01·02·03 cho Tầm nhìn / Sứ mệnh / Giá trị (multirow).
   3) Đếm tăng cho băng số liệu (data-egr-count). */
(function () {
  // Trang About = có section thuộc template id này.
  if (!document.querySelector('.egr-ahero')) return; // 28/09: nhận trang theo hero .egr-ahero — id template cũ 24600514068503 đã đổi nên script từng thoát sớm (video không bấm được)

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- 0) Hero video: click cover → nhúng YouTube tự phát ---------- */
  var vbtn = document.querySelector('.egr-ahero__video[data-egr-yt]');
  if (vbtn) {
    vbtn.addEventListener('click', function () {
      var id = vbtn.getAttribute('data-egr-yt');
      var frame = document.createElement('div');
      frame.className = 'egr-ahero__frame';
      var iframe = document.createElement('iframe');
      iframe.src = 'https://www.youtube.com/embed/' + id + '?autoplay=1&rel=0';
      iframe.title = 'Video eGURU';
      iframe.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
      iframe.setAttribute('allowfullscreen', '');
      iframe.setAttribute('frameborder', '0');
      frame.appendChild(iframe);
      vbtn.replaceWith(frame);
    });
  }

  /* ---------- 2) Số thứ tự cho VMV ---------- */
  var vmvRows = document.querySelectorAll('[id*="__multirow"] .image-with-text');
  Array.prototype.forEach.call(vmvRows, function (row, i) {
    row.classList.add('egr-vmv-row');
    var content = row.querySelector('.image-with-text__content') || row.querySelector('.image-with-text__text-item');
    if (content && !content.querySelector('.egr-vmv-num')) {
      var num = document.createElement('div');
      num.className = 'egr-vmv-num';
      num.textContent = ('0' + (i + 1)).slice(-2);
      content.insertBefore(num, content.firstChild);
    }
  });

  /* ---------- 1) Scroll-reveal ---------- */
  var targets = [];
  document.querySelectorAll('#MainContent > .shopify-section').forEach(function (s) {
    var rows = s.querySelectorAll('.image-with-text');
    if (rows.length > 1) Array.prototype.forEach.call(rows, function (r) { targets.push(r); });
    else targets.push(s);
  });

  if (reduce || !('IntersectionObserver' in window)) {
    targets.forEach(function (el) { el.classList.add('egr-in'); });
  } else {
    targets.forEach(function (el) { el.classList.add('egr-reveal'); });
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('egr-in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    targets.forEach(function (el) { io.observe(el); });
  }

  /* ---------- 3) Đếm tăng ---------- */
  function animateCount(el) {
    var raw = el.getAttribute('data-egr-count');
    var target = parseFloat(raw) || 0;
    var dec = raw.indexOf('.') > -1 ? 1 : 0;
    var dur = 1400, start = null;
    function fmt(v) { return dec ? v.toFixed(1) : Math.round(v).toLocaleString('vi-VN'); }
    function step(ts) {
      if (!start) start = ts;
      var p = Math.min((ts - start) / dur, 1);
      var eased = 1 - Math.pow(1 - p, 3);
      el.textContent = fmt(target * eased);
      if (p < 1) requestAnimationFrame(step); else el.textContent = fmt(target);
    }
    requestAnimationFrame(step);
  }
  var counters = document.querySelectorAll('[data-egr-count]');
  if (counters.length) {
    if (reduce || !('IntersectionObserver' in window)) {
      Array.prototype.forEach.call(counters, animateCount);
    } else {
      var io2 = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) { animateCount(e.target); io2.unobserve(e.target); } });
      }, { threshold: 0.6 });
      Array.prototype.forEach.call(counters, function (c) { io2.observe(c); });
    }
  }
})();
